import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { lazy } from "react";
import { useUserStore } from "@faire/retailer/stores/domain/UserStore";
var _LazyHeaderLanguageSelector = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: "header-language-dropdown" */ "./HeaderLanguageSelector").then(function(m) {
        return {
            default: m.HeaderLanguageSelector
        };
    });
});
export var LazyHeaderLanguageSelector = function(props) {
    var _useUserStore = useUserStore([
        "isImpersonating",
        "userToken"
    ]), isImpersonating = _useUserStore.isImpersonating, userToken = _useUserStore.userToken;
    return /*#__PURE__*/ _jsx(_LazyHeaderLanguageSelector, _object_spread_props(_object_spread({}, props), {
        userToken: isImpersonating ? undefined : userToken
    }));
};
